import { render, staticRenderFns } from "./FundingProjectCollaborationAgreementCard.vue?vue&type=template&id=0f8a3374&"
import script from "./FundingProjectCollaborationAgreementCard.vue?vue&type=script&lang=js&"
export * from "./FundingProjectCollaborationAgreementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports